import { ChatBackIcon, ConversationAvatar, Div, P } from '@vgrubs/components';
import { HeaderActionSlot } from './Chat.styled';

/**
 * The Viktor thread's header: his mark, his name, and the way back on a phone.
 *
 * Nothing on the right, where the human threads keep Archive and Details. The
 * thread is in no list to be archived out of, and it has no members to manage
 * or mute - it is one person and Viktor, for as long as the account lasts.
 * The avatar rides along because the header is the only place in the open
 * thread that says who is answering; the bubbles say it by colour.
 */
export const ViktorThreadHeader = ({ onBack }: { onBack: () => void }) => (
  <Div $flex $alignCenter $gap="12px" style={{ minWidth: 0 }}>
    {/* Mobile only - on desktop the inbox is right there beside the thread,
        so there is nothing to go back to. */}
    <Div $mobile>
      <HeaderActionSlot
        role="button"
        aria-label="Back to conversations"
        onClick={onBack}
      >
        <ChatBackIcon />
      </HeaderActionSlot>
    </Div>

    <ConversationAvatar type="viktor" name="vGrubs AI" size={28} />
    <P $m="0" $bold>
      vGrubs AI
    </P>
  </Div>
);
